import React, { Component } from 'react';
import styled from 'styled-components';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';

import BaseButton from '../BaseButton';

class BorderButton extends Component {
    render() {
        const { className, children, onClick } = this.props;

        return (
            <Root className={className} onClick={onClick}>
                {children}
            </Root>
        );
    }
}

const Root = styled(BaseButton)`
    text-transform: uppercase;
    color: #000000;
    border: 2px solid #000000;
    background: #FFFFFF;

    :active {
        color: #0032A0;
        border: 2px solid #0032A0;
    }

    ${mediaWidth.l} {
        :hover {
            color: #0032A0;
            border: 2px solid #0032A0;
        }
    }
`;

export default BorderButton;
